import { render, staticRenderFns } from "./PanelJsonShow.vue?vue&type=template&id=33bce83e&"
import script from "./PanelJsonShow.vue?vue&type=script&lang=js&"
export * from "./PanelJsonShow.vue?vue&type=script&lang=js&"
import style0 from "./PanelJsonShow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports